import Swal from 'sweetalert2';
import * as actionTypes from '../actionTypes';
import { put, call, takeLeading } from 'redux-saga/effects';
import { getAPI, postAPI, patchAPI } from '../../utils/api-function';
import { create_operator_images, get_operator, get_operator_images, update_operator_images } from '../../utils/api-routes';


function* getOperator() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_operator);
        // console.log("Get Operator Saga Response ::: ", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_OPERATOR, payload: data?.data });
            yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        }

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Operator Saga Error ::: ", error);
    }
}

function* getOperatorImages(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);
        const { operator } = payload;

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_operator_images(operator));
        console.log("Get Operator Images Saga Response ::: ", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_OPERATOR_IMAGES, payload: data?.data });
            yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        }

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Operator Images Saga Error ::: ", error);
    }
}

function* createOperatorImages(action) {
    try {
        const { payload } = action;
        console.log("createOperatorImages Payload ::: ", payload);

        const { data } = yield postAPI(create_operator_images, payload?.data);
        console.log("Create Operator Image Saga Response ::: ", data);

        if (data?.success) {
            Swal.fire({ icon: "success", title: 'Success', text: "Created Successfully", showConfirmButton: false, timer: 2000, });
            yield put({ type: actionTypes.GET_OPERATOR_IMAGES, payload: { operator: { _id: '', name: '' } } });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Create", showConfirmButton: false, timer: 2000 });
        console.log("Create Operator Image Saga Error ::: ", error);
    }
}

function* updateOperatorImages(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const { data } = yield patchAPI(update_operator_images, payload?.data);
        console.log("Update Operator Image Saga Response ::: ", data);

        if (data?.success) {
            Swal.fire({ icon: "success", title: 'Success', text: "Updated Successfully", showConfirmButton: false, timer: 2000, });
            yield put({ type: actionTypes.GET_OPERATOR_IMAGES, payload: { operator: { _id: '', name: '' } } });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Update", showConfirmButton: false, timer: 2000 });
        console.log("Update Operator Image Saga Error ::: ", error);
    }
}

// function* deleteItem(action) {
//     try {
//         const { payload } = action;
//         console.log("Payload ::: ", payload);

//         const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Delete", })
//         if (result.isConfirmed) {
//             const response = yield deleteAPI(delete_item(payload?.id));
//             console.log("Delete Item Saga Response ::: ", response);

//             if (response?.status === 200) {
//                 Swal.fire({ icon: "success", title: 'Success', text: "Deleted Successfully", showConfirmButton: false, timer: 2000, });
//                 yield put({ type: actionTypes.GET_ITEM, payload: null });
//             }
//         }
//     } catch (error) {
//         Swal.fire({ icon: "error", title: 'Failed', text: "Failed To Delete Data", showConfirmButton: false, timer: 2000 });
//         console.log("Delete Item Saga Error ::: ", error);
//     }
// }

export default function* operatorImageSaga() {
    yield takeLeading(actionTypes?.GET_OPERATOR, getOperator);
    yield takeLeading(actionTypes?.GET_OPERATOR_IMAGES, getOperatorImages);
    yield takeLeading(actionTypes?.CREATE_OPERATOR_IMAGES, createOperatorImages);
    yield takeLeading(actionTypes?.UPDATE_OPERATOR_IMAGES, updateOperatorImages);
    // yield takeLeading(actionTypes?.DELETE_ITEM, deleteItem);
};